// device.js — minimal device-class detection used by the customer
// booking photo flow.  isMobile() returns true on real phones/tablets
// OR on any touch-primary device.  Keep this util tiny — frontend
// elsewhere may add more nuanced checks later.
export function isMobile() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/android|iphone|ipad|ipod|mobile/i.test(ua)) return true;
  if (typeof window !== "undefined" && window.matchMedia) {
    try { return window.matchMedia("(pointer: coarse)").matches; } catch { /* noop */ }
  }
  return false;
}
